import React, { Component } from "react";
import "../forms.css";

import Task from "../../../models/Task";
import SubTask from "../../../models/SubTask";
import User from "../../../models/User";

type Props = {
  projectId: string,
  user: User,
  task: Task,
  subTask: SubTask,
  onRequestToggleSubTaskCompleteness: () => void,
  isOwner: boolean,
  accountExpired: boolean,
};

export default class SubtaskForm extends Component {
  props: Props;

  createTaskPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <div className="subtask-info">
        <input
          className="strip-checkinput-styles subtask-checkbox"
          type="checkbox"
          checked={this.props.subTask.isComplete}
          onChange={this.props.onRequestToggleSubTaskCompleteness}
          disabled={!this.props.isOwner || this.props.accountExpired}
        />
        <div className="subtask-details">{this.props.subTask.details}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/subtask-input/SubtaskInput.js